import React from "react";
import PageBanner from "../components/PageBanner";
import Sidebar from "../components/Sidebar";
import { LINKS_SECTIONS, PAGE_BANNERS } from "../data/content";
import { ExternalLink } from "lucide-react";

export default function Links() {
  return (
    <div>
      <PageBanner src={PAGE_BANNERS.resources} alt="Links" fallbackKey="resources" />
      <div className="flex flex-col lg:flex-row gap-8">
        <Sidebar />
        <article className="flex-1 nn-content">
          <h1>Links</h1>
          {LINKS_SECTIONS.map((s) => (
            <section key={s.title}>
              <h2 className="!text-xl">{s.title}</h2>
              <ul>
                {s.items.map((it) => (
                  <li key={it.url}>
                    <a
                      href={it.url}
                      target="_blank"
                      rel="noreferrer"
                      className="nn-link inline-flex items-center gap-1"
                    >
                      {it.label}
                      <ExternalLink className="w-3 h-3 opacity-60" />
                    </a>
                  </li>
                ))}
              </ul>
            </section>
          ))}
        </article>
      </div>
    </div>
  );
}
